import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getRede(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('indicacao/rede', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

  },
}
